import { Box, Typography } from "@mui/material";
import { getCartSummary } from "../utils/getCartSummary";

interface IProps {
  orderSummary: IOrderSummary;
}

const CartTotalPricing: React.FC<IProps> = ({ orderSummary }) => {
  const { subtotal, shipping, tax, discount } = orderSummary;
  const cartSummary = getCartSummary(orderSummary);
  const discountCalc = (subtotal * discount) / 100;
  const grandTotal = subtotal + tax + shipping - discountCalc;
  const newGrandTotal = grandTotal % 1 === 0 ? grandTotal : grandTotal.toFixed(2);
  return (
    <Box
      display="flex"
      flexDirection="column"
      gap={{ xs: 2, md: 3 }}
      mt={3}
      mb={4}
    >
      {cartSummary.map(({ label, value }, index) => (
        <Box
          key={index}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography variant="subtitle1" component="p" color="text.primary">
            {label}
          </Typography>
          <Typography variant="subtitle1" component="p" color="text.primary">
            {value}
          </Typography>
        </Box>
      ))}

      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography
          variant="h4"
          component="p"
          fontSize={{ xs: "1.125rem", md: "1.25rem" }}
          color="text.primary"
        >
          Total (USD)
        </Typography>
        <Typography
          variant="h4"
          component="p"
          fontSize={{ xs: "1.5rem", md: "1.625rem" }}
          color="text.primary"
        >
          ${newGrandTotal}
        </Typography>
      </Box>
    </Box>
  );
};

export default CartTotalPricing;
